import BaseService from '@/ecm/common/BaseService.js';

class EntraIdService {
    baseUrl = 'entraId';
    EntraIdRequest = () => BaseService.get({ url: `${this.baseUrl}/request` });
}
export default new EntraIdService();
